// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NzqAyG1Ih2KtusIldStZ {
  height: 100%;
}
.SnoXgpEz6fzoUOswQwWm {
  padding: 60px 0 40px;
}
.mcOlSe3GmtMa0q7zPZz8 {
  text-align: center;
  font-size: 32px;
}
.qdXWC80VJ_g9OwqAhil1 {
  gap: 24px;
}
.vAWxGUDHgranKLwMDRG4 {
  width: 300px;
  border: 1px solid rgba(13, 13, 13, 0.1);
  border-radius: 16px;
  padding: 24px;
}
.BYgf0bIUskoyOLSzkCrq {
  border: 2px solid #037C4B !important;
  background-color: #f5f5ff;
}
.GxUYAItnd8zib02gylcD {
  font-size: 18px;
}
.UT5yItoF2uTiXpmVcost {
  font-size: 16px;
  font-weight: bold;
}
.oAbpDQRqkniF09pQ2xr8 {
  font-size: 28px;
  font-weight: bold;
  padding: 8px 0;
}
.nuxZA0wKGCv0KGPnS2bN {
  padding-bottom: 8px;
}
.S2X1tswDyH_KBmqdZazg {
  width: 100%;
}
.LCoDwOn19xwLzso_kqmN {
  font-size: 14px;
  font-weight: normal;
  margin-left: 4px;
}
.LyOoUNpppx5gCvXvIVaU {
  padding-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Pricing/style.module.less"],"names":[],"mappings":"AACA;EACE,YAAA;AAAF;AAGA;EACE,oBAAA;AADF;AAIA;EACE,kBAAA;EACA,eAAA;AAFF;AAKA;EACE,SAAA;AAHF;AAMA;EACE,YAAA;EACA,uCAAA;EACA,mBAAA;EACA,aAAA;AAJF;AAOA;EACE,oCAAA;EACA,yBAAA;AALF;AAQA;EACE,eAAA;AANF;AASA;EACE,eAAA;EACA,iBAAA;AAPF;AAUA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AARF;AAWA;EACE,mBAAA;AATF;AAYA;EACE,WAAA;AAVF;AAaA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AAXF;AAcA;EACE,iBAAA;AAZF","sourcesContent":["\n.pageContainer {\n  height: 100%;\n}\n\n.pricingHeader {\n  padding: 60px 0 40px;\n}\n\n.headText {\n  text-align: center;\n  font-size: 32px;\n}\n\n.cards {\n  gap: 24px\n}\n\n.cardContainer {\n  width: 300px;\n  border: 1px solid rgba(13, 13, 13, 0.1);\n  border-radius: 16px;\n  padding: 24px;\n}\n\n.activePlan {\n  border: 2px solid #037C4B !important;\n  background-color: #f5f5ff;\n}\n\n.cardTitle {\n  font-size: 18px;\n}\n\n.subTitle {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.amount {\n  font-size: 28px;\n  font-weight: bold;\n  padding: 8px 0;\n}\n\n.description {\n  padding-bottom: 8px;\n}\n\n.checkout {\n  width: 100%;\n}\n\n.currency {\n  font-size: 14px;\n  font-weight: normal;\n  margin-left: 4px;\n}\n\n.list {\n  padding-left: 8px;\n}\n\n.listItem {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `NzqAyG1Ih2KtusIldStZ`,
	"pricingHeader": `SnoXgpEz6fzoUOswQwWm`,
	"headText": `mcOlSe3GmtMa0q7zPZz8`,
	"cards": `qdXWC80VJ_g9OwqAhil1`,
	"cardContainer": `vAWxGUDHgranKLwMDRG4`,
	"activePlan": `BYgf0bIUskoyOLSzkCrq`,
	"cardTitle": `GxUYAItnd8zib02gylcD`,
	"subTitle": `UT5yItoF2uTiXpmVcost`,
	"amount": `oAbpDQRqkniF09pQ2xr8`,
	"description": `nuxZA0wKGCv0KGPnS2bN`,
	"checkout": `S2X1tswDyH_KBmqdZazg`,
	"currency": `LCoDwOn19xwLzso_kqmN`,
	"list": `LyOoUNpppx5gCvXvIVaU`
};
export default ___CSS_LOADER_EXPORT___;
